import React from "react";
import { useState, useEffect, useMemo } from "react";
import { getMainTableBooking } from "../../actions/home/mainTableBookingAction";
import { getTableGalleryDetail } from "../../actions/menu/tablegalleryAction"
import { getSeoDataApi } from "../../api/seo/seo";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./css/tablebookingmenu.scss";
import { connect, useDispatch, useSelector } from "react-redux";
// import Calendar from "./Calendar";
import DINING from "./img/Dining-offers.png";
import Card from "react-bootstrap/Card";
import { IoChevronBack } from "react-icons/io5";
import { GrCheckmark } from "react-icons/gr";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { Helmet } from "react-helmet";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import FKLOGO from "./img/FK discount logo.png";
import SaleImg from "./img/sale 1.svg";
import LocationImg from "./img/locat.svg";
import ClockImg from "./img/clock.svg";
import peopleImg from "./img/people.svg";
import KITCHENLOGO from "./img/kitchenlogo.gif";
import { useContext } from "react";
// Import Swiper styles
import { Button, Spinner, Image } from "react-bootstrap";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import required modulesimport React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/free-mode";
import BurgerImg from "./img/burger.png";
import orangeImg from "./img/orange.png";
import ThemeContext from "../../common/theme/components/contexts/themecontexts";
import { ClientFeedbackDetail, ResetFeedBack } from "../../actions/feedback/customerFeedBackAction";
import Modal from "react-bootstrap/Modal";
import { Pagination } from "swiper";
import { OrderFlow } from "../../App";
import { Grid } from "@mui/material";
import { getReviewDetail } from "../../actions/menu/reviewAction";
import { useParams } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import { useLocation } from "react-router-dom";
import "pannellum/build/pannellum.css"; // Correct CSS import
import { MdCancel } from "react-icons/md";
import ReactPannellum from "react-pannellum";


function UserDetail() {
  const takeawayName = localStorage.getItem("clientName") || "";
  const takeawayorderpostcode = localStorage.getItem("orderPostcode") || "";

  const getLocalStorageData = () => {
    const storedData = localStorage.getItem("tableBookingAllData");
    if (storedData) {
      return JSON.parse(storedData);
    }
    console.error("No table booking data found in localStorage");
    return null;
  };

  const bookingData = getLocalStorageData();

  return (
    <div className="restaurentUI">
      <div>
        <div className="d-flex justify-content-between mb-3">
          <div className="d-flex justify-content-center align-items-end ">
            <div>
              <img
                src={KITCHENLOGO}
                alt="kitchen logo"
                style={{ height: 80 }}
              />
            </div>
            <div className="tablepaytitle">
              <h5>{takeawayName}</h5>
              <p>{takeawayorderpostcode}</p>
            </div>
          </div>
          <div>
            {/* <p className="editables" onClick={handleNavClicktoback}>
              Edit
            </p> */}
          </div>
        </div>
        <hr className="line" />
        <div className="d-flex justify-content-between flex-wrap mt-3">
          <div className="d-flex justify-content-center align-items-end mb-2">
            <img src={ClockImg} className="custdetailsimg" alt="" />
            <h5 className="custdetails">{bookingData.date}   {bookingData.time}</h5>
          </div>
          <div>
            <div className="d-flex justify-content-center align-items-end mb-2">
              <img src={peopleImg} className="custdetailsimg" alt="" />
              <h5 className="custdetails">Number of guests: {bookingData.people}</h5>
            </div>
          </div>
          <div>
            <div className="d-flex justify-content-center align-items-end mb-2">
              <img src={LocationImg} className="custdetailsimg" alt="" />
              <h5 className="custdetails">{takeawayName}{takeawayorderpostcode}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Tablebook({ getReviewDetail, response, getTableGalleryDetail, tablegalleryresponse }) {
  const navigate = useNavigate();
  const [seoData, setSeoData] = useState();
  const [selectedCell, setSelectedCell] = useState(null);
  const [selectedUI, setSelectedUI] = useState("discountUI");
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [buttonLoading, setButtonLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const loginCheck = localStorage.getItem('isLoggedIn');
  const [show, setShow] = useState(false);
  const [showBookingPopup, setShowBookingPopup] = useState(false); // New state to control booking popup
  const [showPaymentBooking, SetShowPaymentBooking] = useState(false)
  const [errors, setErrors] = useState({});
  const [apiMessage, setApiMessage] = useState(null);
  const [timeOptions, setTimeOptions] = useState([]);
  const [timeLoader, setTimeLoader] = useState(false);
  const [apiStatus, setApiStatus] = useState(null);
  const [paymentTab, setPaymentTab] = useState(false);
  const [depositDetail, setDepositDetail] = useState(false);
  const [depositAmount, setDepositAmount] = useState("0.00");
  const [hasFetched, setHasFetched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const takeawayName = localStorage.getItem("clientName") || "";
  const [topHeaderStatus, setTopHeaderStatus] = useState(false);
  const { loginPopupShow, setLoginPopupShow } =
    OrderFlow();
  const canonicalUrl = `${window.location.origin}${location.pathname}`;
  const tableGalleryData = tablegalleryresponse?.Data;
  const menuImage = tablegalleryresponse?.Data?.menuimg;
  const menuImage1 = tablegalleryresponse?.Data;
  console.log(tableGalleryData, menuImage1);
  console.log(menuImage1);

  const tablebookimage360 = tablegalleryresponse?.Data?.tablegallery;
  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = 767;
  const { setTableBookingAllData } = OrderFlow();
  const { theme } = useContext(ThemeContext);
  const [showBookingForm, setShowBookingForm] = useState(false); // State for showing/hiding form

  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleBookSeatClick = () => {
    setShowBookingForm(true); // Show booking form
  };

  // const [activeButton, setActiveButton] = useState(null);
  const handleUISelection = (ui) => {
    setSelectedUI(ui);
  };
  const handleNavClicktoback = () => {
    navigate(-1); // Navigate back to the previous page
  };

  const handleClose = () => setShow(false);

  const closeBookingPopup = () => {
    setShowBookingPopup(false); // Close the booking popup
  };

  ///// New validation code
  const [formData, setFormData] = useState({
    date: "",
    time: "",
    people: "",
  });

  const [dinerDetails, setDinerDetails] = useState({
    firstname: "",
    lastname: "",
    phone: "",
    email: "",
    notes: "",
  });

  const validateMobileNumber = (number) => {
    const mobileRegex = /^\d{11}$/;
    if (!number.trim()) {
      return { valid: false, message: "Phone number is required." };
    }
    if (!mobileRegex.test(number)) {
      return { valid: false, message: "Phone number must be exactly 11 digits." };
    }
    return { valid: true, message: "" };
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);
    setErrors({ ...errors, [name]: "" });
    setApiMessage(null);

    if (name === "date") fetchTimeSlots(value);
    updateSetTableBookingAllData(updatedFormData, dinerDetails);
  };

  const handleDinerDetailsChange = (e) => {
    const { name, value } = e.target;
    const updatedDinerDetails = { ...dinerDetails, [name]: value };
    setDinerDetails(updatedDinerDetails);
    setErrors({ ...errors, [name]: "" });
    updateSetTableBookingAllData(formData, updatedDinerDetails);
  };

  const updateSetTableBookingAllData = (formData, dinerDetails) => {
    const combinedData = { ...formData, ...dinerDetails };
    localStorage.setItem('tableBookingAllData', JSON.stringify(combinedData));
    setTableBookingAllData(combinedData);
  };

  const fetchTimeSlots = (date) => {
    if (!date) return;
    setTimeLoader(true);
    setHasFetched(false); // Reset flag before the API call

    const apiUrl = "https://api-new.fusionkitchen.co.uk/getTableTiming";
    fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ domain: window.location.hostname, date }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status && data.message) {
          const times = data.message.split(",");
          if (times.length > 0) {
            setTimeOptions(times.map((time) => ({ time, discount: time.includes("20% off") })));
          } else {
            setTimeOptions([]);
          }
        } else {
          setTimeOptions([]);
        }
      })
      .catch(() => {
        setTimeOptions([]);
      })
      .finally(() => {
        setTimeLoader(false);
        setHasFetched(true); // Indicate the API call is complete
      });
  };


  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    let firstInvalidField = null; // Store the first invalid field

    const setError = (field, message) => {
      newErrors[field] = message;
      if (!firstInvalidField) firstInvalidField = field; // Track first invalid field
      isValid = false;
    };

    if (!formData.date) setError("date", "Date is required.");
    if (!formData.time) setError("time", "Time is required.");
    if (!formData.people || formData.people === "Select Guests") setError("people", "Number of guests is required.");
    if (!dinerDetails.firstname.trim()) setError("firstname", "First name is required.");
    if (!dinerDetails.lastname.trim()) setError("lastname", "Last name is required.");
    if (!dinerDetails.email.trim() || !/^\S+@\S+\.\S+$/.test(dinerDetails.email)) {
      setError("email", "A valid email address is required.");
    }

    const phoneValidation = validateMobileNumber(dinerDetails.phone);
    if (!phoneValidation.valid) setError("phone", phoneValidation.message);

    if (dinerDetails.notes.length > 200) setError("notes", "Notes cannot exceed 200 characters.");

    // Set errors in state
    setErrors(newErrors);

    // Scroll and focus on the first invalid field
    if (firstInvalidField) {
      setTimeout(() => {
        const element = document.querySelector(`[name="${firstInvalidField}"]`);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          element.focus();
        }
      }, 100);
    }

    return isValid;
  };


  const handleProceedClick = (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    setIsLoading(true);
    // setIsButtonDisabled(true); // Disable button during API calls

    // First, check availability
    const availabilityApiUrl = "https://api-new.fusionkitchen.co.uk/CheckTableAvaliablity";
    const availabilityRequestData = {
      domain: window.location.hostname,
      date: formData.date,
      time: formData.time,
      people: formData.people,
    };

    fetch(availabilityApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(availabilityRequestData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Check Availability API Response:", data);
        if (data.status) {
          setApiStatus(data.status);
          setApiMessage(null); // Reset any previous error messages
          // Proceed with booking after availability check
          const bookingApiUrl = "https://api-new.fusionkitchen.co.uk/bookTableForNow";
          const bookingRequestData = {
            domain: window.location.hostname,
            date: formData.date,
            time: formData.time,
            people: formData.people,
            status: 1,
            ...dinerDetails,
          };

          return fetch(bookingApiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(bookingRequestData),
          });
        } else {
          setApiStatus(false);
          setApiMessage(data.message || "Error checking availability.");
          throw new Error(data.message || "Error checking availability.");
        }
      })
      .then((response) => {
        if (!response.ok) {
          // Handle non-200 status codes
          return response.json().then((errorData) => {
            throw new Error(errorData.message || "An error occurred.");
          });
        }
        return response.json();
      })
      .then((data) => {
        console.log("API Response:", data);

        if (data.status) {
          if (data.message === "Table Booked") {
            setApiMessage({ type: "success", message: "Booking successful!" });
            setFormData({
              date: "",
              time: "",
              people: "",
            });

            setDinerDetails({
              firstname: "",
              lastname: "",
              email: "",
              phone: "",
              notes: "",
            });
            setModalShow(true);
            // toast.success("Table booked  successfully!");
            // setModalShow(true); // Uncomment to show modal for successful booking
          } else {
            // Handle payment-related logic
            setPaymentTab(data.status);
            setDepositDetail(data.deposit);

            if (data.deposit?.isActive === 1) {
              if (data.deposit.perPerson === 1) {
                const people = formData.people.split(" ");
                const depositAmount = (data.deposit.amount * people[0]).toFixed(2);
                setDepositAmount(depositAmount);
                localStorage.setItem("depositAmount", depositAmount);
                localStorage.setItem("original_deposit", data.deposit.amount)
              } else {
                const depositAmount = data.deposit.amount;
                setDepositAmount(depositAmount);
                console.log(depositAmount);

                // Store deposit amount in localStorage
                localStorage.setItem("depositAmount", depositAmount);
                localStorage.setItem("original_deposit", data.deposit.amount)
              }
            }

            // Redirect to payment page
            navigate("/tablebookingpayment");
          }
        } else {
          // Handle cases where `data.status` is not available
          setApiMessage({ type: "success", message: "Booking successful without payment!" });
          // setModalShow(true); // Uncomment to show modal for successful booking without payment
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setApiMessage({ type: "error", message: error.message || "An error occurred while submitting the booking." });
        toast.error(` ${error.message || "Table Booking Failed"}`);
      })
      .finally(() => {
        setIsLoading(false);
        // setIsButtonDisabled(false); // Re-enable button after both requests
      });
  };

  const handleCheckStatus = () => {
    const loginCheck = localStorage.getItem('isLoggedIn');

    if (loginCheck === 'true') {
      // Redirect based on screen width
      if (width > breakpoint) {
        navigate('/myaccount/tablebooking'); // Desktop view
      } else {
        navigate('/tablebooking'); // Mobile view
      }
    } else {
      setModalShow(false);
      setLoginPopupShow(true);
    }
  };
  useEffect(() => {
    const loginCheck = localStorage.getItem('isLoggedIn');
    if (loginCheck === 'true' && loginPopupShow) {
      navigate('/myaccount/tablebooking');
      setLoginPopupShow(false); // Close the popup after navigation
    }
  }, [loginPopupShow]);
  const getLocalStorageData = () => {
    const storedData = localStorage.getItem("tableBookingAllData");
    if (storedData) {
      return JSON.parse(storedData);
    }
    console.error("No table booking data found in localStorage");
    return null;
  };

  const bookingData = getLocalStorageData();

  const FrokIcon = 'https://fusionbucket.co.uk/tablebooking-new/Vector (4).png';
  const { path } = useParams();
  const formDatatablegallery = useMemo(() => {
    return {
      client_path: path,
      domain: window.location.hostname,
    };
  }, [path]);
  useEffect(() => {
    getTableGalleryDetail(formDatatablegallery);
  }, [getTableGalleryDetail, formDatatablegallery]);

  const formDatareview = useMemo(() => {
    return {
      client_path: path,
    };
  }, [path]);

  useEffect(() => {
    getReviewDetail(formDatareview);
  }, [getReviewDetail, formDatareview]);

  const getFirstWords = (text, wordCount) => {
    const words = text.split(" ");
    return (
      words.slice(0, wordCount).join(" ") +
      (words.length > wordCount ? "..." : "")
    );
  };
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const reviewbutton = "https://fusionbucket.co.uk/tablebooking-new/reviewbutton.jpg"
  const personreview = "https://fusionbucket.co.uk/tablebooking-new/personreview.jpg"

  const feedbackStatus = useSelector(state => state.ClientFeedbackReducer);

  // Generate a unique ID for the toast
  const toastId = "feedback-toast-id"; // You can use a static or dynamic ID here

  useEffect(() => {
    if (loginCheck) {
      const clientEmail = localStorage.getItem('email');
      setEmail(clientEmail);
    }
  }, [loginCheck]);

  useEffect(() => {
    if (feedbackStatus?.response) {
      setButtonLoading(false);
      setMessage("");

      // Check if the toast with this id is already active
      if (!toast.isActive(toastId)) {
        toast.success("Feedback added successfully!", {
          toastId: toastId // Use the unique toast ID
        });
      }

      dispatch(ResetFeedBack());
      setTimeout(() => {
        setModalOpen(false); // Close modal after slight delay
      }, 500);
    }
  }, [feedbackStatus, dispatch, handleClose]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const userAgents = navigator.userAgent;
    const pathName = location.pathname;

    const data = {
      path: pathName,
      userAgent: userAgents,
      email: email,
      comment: message
    };

    dispatch(ClientFeedbackDetail(data));
    setButtonLoading(true);
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };
  const [isModalOpenGrid, setIsModalOpenGrid] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Function to toggle modal
  const handleClickGrid = (img) => {
    setIsModalOpenGrid(true);
    if (img) {

      setSelectedImage(img); // Set the selected image
      setIsModalOpenGrid(true);
    }
  };
  const [imageBlobUrl, setImageBlobUrl] = useState(null);
  const ThreeSixtyIMG = tableGalleryData?.tablegallery?.[2]?.img;

  useEffect(() => {
    const fetchBlob = async () => {
      if (!ThreeSixtyIMG) return;

      try {
        const response = await fetch(ThreeSixtyIMG, {
          mode: "cors", // Request with CORS mode enabled
        });

        if (!response.ok) throw new Error("Failed to fetch image");

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        setImageBlobUrl(blobUrl);
      } catch (error) {
        console.error("Error fetching image:", error);
      }
    };

    fetchBlob();

    return () => {
      if (imageBlobUrl) URL.revokeObjectURL(imageBlobUrl);
    };
  }, [ThreeSixtyIMG]);

  const handleCloseGrid = () => {
    setIsModalOpenGrid(false);
    setSelectedImage(null);
  };
  const customStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
      zIndex: 1000,
    },
    content: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      border: 'none',
      background: 'black',
      overflow: 'hidden',
      WebkitOverflowScrolling: 'touch',
      outline: 'none',
      padding: 0,
    },
  };

  const bookingDate = new Date(bookingData?.date); // Assuming bookingData.date is in "YYYY-MM-DD" format
  const formattedDate = bookingDate.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
  }); // Formats date like "30 January"
  const displayValue = topHeaderStatus ? '0' : '1';

  useEffect(() => {
    const fetchData = async () => {
      try {
        const formData = {
          domain: window.location.hostname,
        };
        const apiResponse = await getSeoDataApi(formData);
        if (apiResponse?.data?.status === false) {
          console.error(
            "Error fetching sitemap data:",
            apiResponse.data.message
          );
        } else {
          setSeoData(apiResponse.data.message);
        }
      } catch (error) {
        console.error("Error fetching sitemap data:", error);
      }
    };

    fetchData();
  }, []);

  const config1 = {
    autoRotate: -2,
  };
  const dynamicStyle = {
    fontSize: "1.2em",
    marginTop: window.innerWidth >= 768 ? "30px" : "0px",
  };



  return (
    <>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>{seoData?.title?.reservation}</title>
        {Array.isArray(seoData?.meta?.reservation) &&
          seoData?.meta?.reservation.map((data, index) => (
            <meta name={data.value} content={data.content} key={index} />
          ))}
        <style type="text/css">{`
          @media only screen and (min-width: 320px) and (max-width: 767px) {
            nav.main-header .logo img{
              visibility:hidden!important;
            }
                  .nav.main-header {
        border-top: block;
        display: block;
    }
            .scroll-header .scroll-header-visible{
             width: 80%;
            }
            .scroll-header-content {
              margin-top: 12px;
            }
            button.navbar-toggler.collapsed{
                margin-top: 12px;
                opacity:${displayValue};
            }
          }
      `}</style>
      </Helmet>
      <Helmet>
        <style type="text/css">{`
        @media only screen and (min-width: 320px) and (max-width: 767px) {
              .logo{
           visibility: hidden !important;
           }
.cartmobile{
visibility: hidden !important;
}
            nav.main-header.logo img{
              visibility:hidden!important;
            }
           navbar.logo img{
           visibility:hidden!important;
           }
           .button.navbar-toggler.collapsed{
               visibility: visible !important;
           }
            .sticky-top{
              padding-bottom: 15px !important;
            }
            .scroll-header .scroll-header-visible{
             width: 80%;
            }
            .scroll-header-content {
              margin-top: 12px;
            }
            button.navbar-toggler.collapsed{
                margin-top: 12px;
                opacity:${displayValue};
            }
                .top-to-btm{
                 display:none;
                 }
                  @media only screen and (min-width: 320px) and (max-width: 767px){
         .menu-page .main-page .outlet-section{
                  padding: 0px 0px !important;
                  }
            }
          }
      `}</style>
      </Helmet>
      {width > breakpoint ? (
        <>
          <div id="tablebook">
            <section>
              <div className="sticky-header d-block d-sm-none">
                <div className="d-flex gap-3" style={{ margin: "10px" }}>
                  <div className="mobileback">
                    <IoChevronBack
                      onClick={handleNavClicktoback}
                      style={{ color: "#000" }}
                    />
                  </div>
                  <div className="gap-4 newdetails">
                    <h5> Reservation Details</h5>
                  </div>
                </div>
              </div>
              <Container>
                <Row>
                  <Col xs={12} md={8}>
                    <Card
                      border="primary"
                      className="d-block d-sm-none primarycards"
                      style={{ width: "100%", border: "none" }}
                    >
                    </Card>
                    <div className="container booking-container">
                      <h5 className="headertext">Please Select your booking details</h5>
                      <Form>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group>
                              <Form.Control
                                type="date"
                                name="date"
                                min={new Date().toISOString().split("T")[0]}
                                placeholder="Select Date"
                                onChange={handleInputChange}
                                isInvalid={!!errors.date}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.date}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Select
                                name="people"
                                onChange={handleInputChange}
                                isInvalid={!!errors.people}
                              >
                                <option>Select Guests</option>
                                {[...Array(30).keys()].map((num) => (
                                  <option key={num + 1}>{num + 1} Guests</option>
                                ))}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                {errors.people}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        {timeLoader ? (
                          <Spinner animation="border" />
                        ) : hasFetched && timeOptions.length > 0 ? (
                          <>
                            <h5 className="my-3 headertext">Select Time</h5>
                            <div className="time-selection-container">
                              <Row className="justify-content-center">
                                {timeOptions.map(({ time, discount }) => (
                                  <Col
                                    key={time}
                                    className="time-selection-button-container"
                                    md={2} // Ensures 5 items per row
                                  >
                                    <Button
                                      variant={formData.time === time ? "primary" : "light"}
                                      className={`time-button ${formData.time === time ? "selected" : ""}`} // Add selected class conditionally
                                      onClick={() => {
                                        const updatedFormData = { ...formData, time };
                                        setFormData(updatedFormData);
                                        updateSetTableBookingAllData(updatedFormData, dinerDetails);
                                      }}
                                    >
                                      {discount && <span className="badge bg-info me-1">20% off</span>}
                                      <div className="time-text">{time}</div>
                                    </Button>
                                  </Col>
                                ))}
                              </Row>
                            </div>
                          </>
                        ) : (
                          hasFetched && <p className="text-danger my-3">The chosen date does not have the selected time slot available.</p>
                        )}

                        {errors.time && <div className="text-danger mb-3">{errors.time}</div>}
                        <h5 className="my-3 headertext">Enter Guest Details</h5>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name="firstname"
                                placeholder="First name"
                                onChange={handleDinerDetailsChange}
                                isInvalid={!!errors.firstname}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.firstname}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name="lastname"
                                placeholder="Last name"
                                onChange={handleDinerDetailsChange}
                                isInvalid={!!errors.lastname}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.lastname}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group>
                              <Form.Control
                                type="email"
                                name="email"
                                placeholder="Email"
                                onChange={handleDinerDetailsChange}
                                isInvalid={!!errors.email}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.email}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name="phone"
                                placeholder="Phone"
                                onChange={handleDinerDetailsChange}
                                isInvalid={!!errors.phone}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.phone}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Form.Group className="mb-3">
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="notes"
                            placeholder="Notes "
                            onChange={handleDinerDetailsChange}
                            isInvalid={!!errors.notes}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.notes}
                          </Form.Control.Feedback>
                        </Form.Group>
                        <p
                          type="submit"
                          className="table-button"
                          onClick={handleProceedClick}
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <>
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                              <span className="ms-2">Processing...</span>
                            </>
                          ) : (
                            "Proceed"
                          )}
                        </p>
                        <ToastContainer
                          position="top-right"
                          autoClose={5000}
                          hideProgressBar={false}
                          newestOnTop={false}
                          closeOnClick
                          rtl={false}
                          pauseOnFocusLoss
                          draggable
                          pauseOnHover
                          theme="colored"
                        />
                      </Form>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div
                      style={{
                        // background: "#ccc",
                        borderRadius: "11px",
                        // height: "204px",
                        paddingTop: "18px",
                      }}
                    >
                      <div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            position: "relative",
                            borderRadius: "11px",
                            height: "auto",
                          }}
                        >
                          {!selectedCell && (
                            <div>
                              <div className="d-none d-md-block dining-img">
                                <img src={DINING} alt="" />
                              </div>
                              {/* <p className="paragraph d-none d-md-block">
                                Select your preferred time slot and we will get you
                                the best offers at this restaurant
                              </p> */}
                              {/* <div className="discount-card">
                                <div className="card-content">
                                  <div className="text-contentdesk">
                                    <h2>Flat {tableGalleryData?.flatoffer}% OFF</h2>
                                    <p>Available for limited offers</p>
                                  </div>
                                  <div className="text-contentbtn">
                                    <img src={FrokIcon} alt="frokicon" className="frokiconimage" />
                                   
                                  </div>
                                </div>
                                <div className="slot-info">
                                  {tableGalleryData?.tablebookingcount}
                                </div>
                              </div> */}
                            </div>
                          )}
                          {selectedCell && (
                            <>
                              <div
                                className={
                                  selectedUI === "discountUI"
                                    ? "discountUI"
                                    : "discountUI2"
                                }
                                onClick={() => handleUISelection("discountUI")}
                              >
                                <div>
                                  <img
                                    src={SaleImg}
                                    alt=""
                                    style={{ margin: "0", maxWidth: "100%" }}
                                  />
                                </div>
                                <div className="offertext">
                                  <p>
                                    <b>20% flat OFF on bill</b> <br />
                                  </p>
                                  <p className="bookingFeeText">
                                    Booking fee: £5 per Person
                                  </p>
                                </div>
                                {selectedUI === "discountUI" && <GrCheckmark />}
                              </div>
                              <div
                                className={
                                  selectedUI === "discountUI2"
                                    ? "discountUI"
                                    : "discountUI2"
                                }
                                onClick={() => handleUISelection("discountUI2")}
                              >
                                <div>
                                  <img
                                    src={FKLOGO}
                                    alt=""
                                    style={{ margin: "0", maxWidth: "100%" }}
                                  />
                                </div>
                                <div className="offertext">
                                  <p>
                                    <b>Gold offer 25% flat OFF on bill</b> <br />
                                  </p>
                                  <p className="bookingFeeText">
                                    No Booking fee applicable
                                  </p>
                                </div>
                                {selectedUI === "discountUI2" && <GrCheckmark />}
                              </div>
                            </>
                          )}
                        </div>
                        {/* <div className="order-btn d-none d-sm-block">
                        <button style={{ width: "100%" }} onClick={handleSubmit}>
                          Select all options to proceed
                        </button>
                      </div> */}
                      </div>
                      <div className="slider-content">
                        <div
                          className="d-none d-sm-block"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <h4>Our food & Ambience Gallery</h4>
                          <p className="text-center">
                            Reserve tables & manage your Reservations
                            <br /> right from your phone!
                          </p>
                        </div>

                        <div className="Slider-section d-none d-sm-block">
                          <div
                            style={{
                              // overflow: "hidden",
                              // height: "330px",
                              // borderRadius: "20px",
                            }}
                          >
                            <Card id="imgcard">
                              <Swiper
                                slidesPerView={"auto"}
                                spaceBetween={30}
                                pagination={{
                                  clickable: true,
                                }}
                                modules={[Pagination]}
                                className="mySwiper"
                                style={{ padding: "0px", backgroundColor: "none !important" }}
                                autoplay={{ delay: 1000 }}
                              >
                                {tablebookimage360?.[0]?.full_img === "0"
                                  ? tablebookimage360.map((image, index) => (
                                    <SwiperSlide
                                      key={index}
                                      className="swiper-slide-custom"
                                      style={{ padding: "0px", cursor: "pointer" }}
                                    >
                                      <img src={image.img} />
                                    </SwiperSlide>
                                  ))
                                  : tableGalleryData?.tablegallery?.map((image, index) => (
                                    <SwiperSlide
                                      key={index}
                                      className="swiper-slide-custom"
                                      style={{ padding: "0px", cursor: "pointer" }}
                                      onClick={() => handleClickGrid(image.img)} // Open modal on any image click
                                    >
                                      <img src={image.img} />
                                    </SwiperSlide>
                                  ))}
                              </Swiper>
                            </Card>

                            {/* Modal only opens if full_img === "1" */}
                            {/* {isModalOpenGrid && selectedImage && (
                              <Modal show={isModalOpenGrid} onRequestClose={handleCloseGrid} style={customStyles}>
                                <Button
                                  onClick={handleCloseGrid}
                                  style={{
                                    position: "absolute",
                                    top: "0px",
                                    right: "0px",
                                    backgroundColor: "transparent",
                                    color: "white",
                                    border: "none",
                                    padding: "15px",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    zIndex: 1001,
                                  }}
                                >
                                  <MdCancel />
                                </Button>

                                <Pannellum
                                  width="100%"
                                  height="1000px"
                                  image={selectedImage}
                                  pitch={10}
                                  yaw={180}
                                  hfov={110}
                                  autoLoad
                                  showZoomCtrl
                                />
                              </Modal>
                            )} */}

                            <p
                              className="text-center"
                              style={{ padding: "10px", textDecoration: "underline", cursor: "pointer" }}
                            >
                              <Link to="/termsandcondition" style={{ textDecoration: "none", color: "inherit" }}>
                                <b>Terms & Conditions</b>
                              </Link>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
          </div>
        </>
      ) : (
        <>
          <div>
            <section className="tablebookmobile">
              {!showBookingForm && (
                <>
                  <div className="tablebookingoffer">
                    {/* <h4 className="prebookhtag">Pre Book Offers</h4> */}
                    {/* <h6 className="slothtag">Limited Slots with Extra Offers</h6> */}
                    {/* <div className="discount-card">
                      <div className="card-content">
                        <div className="text-content">
                          <h2>Flat {tableGalleryData?.flatoffer}% OFF</h2>
                          <p>Available for limited offers</p>
                        </div>
                        <div className="text-contentbtn">
                          <img src={FrokIcon} alt="frokicon" className="frokiconimage" />
                          <button className="book-now-btn" onClick={handleBookSeatClick}>Book Now</button>
                        </div>
                      </div>
                      <div className="slot-info">
                        {tableGalleryData?.tablebookingcount}
                      </div>
                    </div> */}
                     {menuImage?.some((item) => item?.imagename) && (
                    <div className="top-dishes">
                     
                        <>
                          <h4>Menu</h4>
                          <h5>Top Dishes</h5>
                          <div className="dishes-container">
                            {menuImage.map((i, v) => (
                              <div className="dish-card" key={v}>
                                <img src={i?.imagename} alt={i?.title} className="dish-image" />
                                <h3>{i?.title}</h3>
                              </div>
                            ))}
                          </div>
                        </>
                      
                    </div>
                    )}
                    {tableGalleryData?.tablegallery &&
                      <div className="photo-grid">
                        <h4>
                          Photos
                        </h4>
                        <Grid container spacing={2}>
                          {/* Large Main Image */}
                          <Grid
                            item
                            xs={8}
                            className="mainlargeimage"
                            // onClick={() =>
                            //   tablebookimage360?.[0]?.full_img === "1" &&
                            //   handleClickGrid(tableGalleryData?.tablegallery?.[0]?.img)
                            // }
                            style={{
                              cursor: tablebookimage360?.[0]?.full_img === "1" ? "pointer" : "default",
                            }}
                          >
                            {tableGalleryData?.tablegallery?.[0]?.img &&
                              <div className="grid-item">
                                <Image src={tableGalleryData?.tablegallery?.[0]?.img} fluid className="griditemlargeimage" />
                              </div>
                            }
                          </Grid>


                          {/* Show Modal When full_img === "1" */}
                          {isModalOpenGrid && (
                            <Modal
                              show={isModalOpenGrid}
                              onRequestClose={handleCloseGrid}
                              style={{ ...customStyles, content: { ...customStyles.content, height: '100vh' } }}
                              ariaHideApp={false}
                              id="custommodal-tablebook"
                            >
                              <button
                                onClick={handleCloseGrid}
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  backgroundColor: "transparent",
                                  color: "white",
                                  border: "none",
                                  padding: "15px",
                                  fontSize: "24px",
                                  cursor: "pointer",
                                  zIndex: 1001,
                                }}
                              >
                                <MdCancel />
                              </button>

                              <div id="custommodal-tablebook-content" style={{ height: '100vh', overflow: 'auto' }}>
                                <ReactPannellum
                                  id="1"
                                  sceneId="firstScene"
                                  image={imageBlobUrl} // ✅ Blob URL instead of direct URL
                                  config={config1}
                                  className="pnlm-container"
                                  width="100%"
                                  height="100vh"
                                />
                              </div>
                            </Modal>
                          )}

                          {/* Additional Images (Right Side) */}
                          <Grid item xs={4}>
                            <Grid container direction="column" spacing={2}>
                              {[1, 2].map((index) => (
                                tableGalleryData?.tablegallery?.[index]?.img && ( // Ensure image exists
                                  <Grid item xs={6} key={index}>
                                    <div
                                      className="grid-item"
                                      // onClick={() =>
                                      //   tableGalleryData?.tablegallery?.[index]?.full_img === "1"
                                      //     ? handleClickGrid(tableGalleryData?.tablegallery?.[index]?.img)
                                      //     : undefined
                                      // }
                                      style={{
                                        cursor:
                                          tableGalleryData?.tablegallery?.[index]?.full_img === "1" ? "pointer" : "default",
                                      }}
                                    >
                                      <Image
                                        src={tableGalleryData?.tablegallery?.[index]?.img}
                                        alt={`Vertical Image ${index}`}
                                        className="griditemsecondcolimage"
                                      />
                                    </div>
                                  </Grid>
                                )
                              ))}
                            </Grid>
                          </Grid>

                          {/* Second Row - Three Images (Fixed to Show All) */}
                          <Grid container spacing={2} style={{ margin: "5px" }}>
                            {[3, 4, 5].map((index) => (
                              <Grid item xs={4} key={index} style={{ marginTop: "5px" }} >
                                {tableGalleryData?.tablegallery?.[index]?.img ? (
                                  <div
                                    className="grid-item"
                                    // onClick={() =>
                                    //   tableGalleryData?.tablegallery?.[index]?.full_img === "1"
                                    //     ? handleClickGrid(tableGalleryData?.tablegallery?.[index]?.img)
                                    //     : undefined
                                    // }
                                    style={{
                                      cursor:
                                        tableGalleryData?.tablegallery?.[index]?.full_img === "1" ? "pointer" : "default",
                                    }}
                                  >
                                    <Image
                                      src={tableGalleryData?.tablegallery?.[index]?.img}
                                      alt={`Gallery Image ${index}`}
                                      className="tablegalleryimage"
                                    />
                                  </div>
                                ) : (
                                  <>
                                  </>
                                  // <div className="grid-item" style={{ height: "150px", background: "#ddd" }}>
                                  //   No Image
                                  // </div>
                                )}
                              </Grid>
                            ))}
                          </Grid>
                        </Grid>


                      </div>
                    }
                    <div className="reviews-container">
                      <h4>Reviews</h4>

                      <Slider {...settings} className="slider-content">
                        {response?.review.map((ClientReview, index) => (
                          <div key={index}>
                            <div className="review-card">
                              <div className="review">
                                <div className="review-header">
                                  <div className="avatar">
                                    <img src={personreview} alt="personicon" className="personicon" />
                                  </div>
                                  <div>
                                    <h5 className="review-name">{ClientReview.name}</h5>
                                    <p className="review-time">{ClientReview.date}</p>
                                  </div>
                                </div>
                                <p className="review-text">{getFirstWords(ClientReview.comment, 35)}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </Slider>

                      {/* Leave a Review Card */}
                      <div className="card-itemreview">
                        <div className="card-itemsprofile" onClick={openModal} >
                          <div className="icon-profile">
                            <img src={reviewbutton} alt="reviewbutton" className="reviewbutton" />
                          </div>
                          <span className="title">Leave a Review</span>
                          <div className="text-content">
                          </div>
                          {/* <div className="arrow">
                            <img src="https://fusionbucket.co.uk/BlogImages/Arrow-vector.png" alt="" />
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <>
                {showBookingForm && (
                  <div className="container booking-container">
                    <h5 className="headertext">Please Select your booking details</h5>
                    <Form>
                      <Row className="mb-3">
                        <Col md={6}>
                          <Form.Group>
                            <DatePicker
                              selected={formData.date ? new Date(formData.date) : null}
                              onChange={(date) => handleInputChange({ target: { name: "date", value: date.toISOString().split("T")[0] } })}
                              dateFormat="dd-MM-yyyy"
                              minDate={new Date()}
                              placeholderText="dd-mm-yyyy"
                              className="form-datapicker"
                              isInvalid={!!errors.date}
                              wrapperClassName="w-100"
                            />
                            {errors.date && (
                              <div className="invalid-feedback">{errors.date}</div>
                            )}
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Select
                              name="people"
                              onChange={handleInputChange}
                              isInvalid={!!errors.people}
                            >
                              <option>Select Guests</option>
                              {[...Array(30).keys()].map((num) => (
                                <option key={num + 1}>{num + 1} Guests</option>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.people}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      {timeLoader ? (
                        <Spinner animation="border" />
                      ) : hasFetched && timeOptions.length > 0 ? (
                        <>
                          <h5 className="my-3 headertext">Select Time</h5>
                          <div className="time-selection-container">
                            <Row className="justify-content-center">
                              {timeOptions.map(({ time, discount }) => (
                                <Col
                                  key={time}
                                  className="time-selection-button-container"
                                  xs={4} // Ensures 5 items per row
                                >
                                  <Button
                                    variant={formData.time === time ? "primary" : "light"}
                                    className={`time-button ${formData.time === time ? "selected" : ""}`} // Add selected class conditionally
                                    onClick={() => {
                                      const updatedFormData = { ...formData, time };
                                      setFormData(updatedFormData);
                                      updateSetTableBookingAllData(updatedFormData, dinerDetails);
                                    }}
                                  >
                                    {discount && <span className="badge bg-info me-1">20% off</span>}
                                    <div className="time-text">{time}</div>
                                  </Button>
                                </Col>
                              ))}
                            </Row>
                          </div>
                        </>
                      ) : (
                        hasFetched && <p className="text-danger my-3">The chosen date does not have the selected time slot available.</p>
                      )}
                      {errors.time && <div className="text-danger mb-3">{errors.time}</div>}
                      <h5 className="my-3 headertext">Enter Guest Details</h5>
                      <Row className="mb-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name="firstname"
                              placeholder="First name"
                              onChange={handleDinerDetailsChange}
                              isInvalid={!!errors.firstname}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.firstname}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="inputsecond">
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name="lastname"
                              placeholder="Last name"
                              onChange={handleDinerDetailsChange}
                              isInvalid={!!errors.lastname}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.lastname}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Control
                              type="email"
                              name="email"
                              placeholder="Email"
                              onChange={handleDinerDetailsChange}
                              isInvalid={!!errors.email}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.email}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="inputsecond">
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name="phone"
                              placeholder="Phone"
                              onChange={handleDinerDetailsChange}
                              isInvalid={!!errors.phone}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.phone}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Form.Group className="mb-3">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          name="notes"
                          placeholder="Notes "
                          onChange={handleDinerDetailsChange}
                          isInvalid={!!errors.notes}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.notes}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <p
                        type="submit"
                        className="table-button"
                        onClick={handleProceedClick}
                        disabled={isLoading} // Disable button when loading
                      >
                        {isLoading ? (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                            <span className="ms-2">Processing...</span>
                          </>
                        ) : (
                          "Book a Seat"
                        )}
                      </p>
                      <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                      />
                    </Form>
                  </div>)}
              </>
              {!showBookingForm && (
                <div id="mybutton" className="d-block d-sm-none">
                  <button className="feedback" onClick={handleBookSeatClick}>
                    Book a Seat
                  </button>
                  {/* <button className="feedbacks" onClick={handlePayBillClick}>
                Pay Bill
              </button> */}
                </div>
              )}
              {showPaymentBooking && (
                <div>
                  <div className="dark-background"></div>
                  <div className="bookingpopup">
                    <div className="bookingpopup-content">
                      <span className="close" onClick={closeBookingPopup}>
                        &times;
                      </span>
                      <h6>Pay to ragam Kitchen</h6>
                      <div
                        style={{
                          marginTop: "35px",
                          marginBottom: "30px",
                        }}
                      >
                        <div className="bookbutton">
                          <span className="content">
                            <b>
                              <h6>Guaranteed Discount</h6>
                            </b>
                            <p>FLAT 10% off on total bill</p>
                          </span>
                          <span className="bookbadge">
                            <img src={BurgerImg} alt="" />
                          </span>
                          <span className="bookbadge2">
                            <img src={orangeImg} alt="" />
                          </span>
                        </div>
                      </div>
                      <div className="form-input">
                        <input
                          type="email"
                          placeholder="Enter amount as shown on the bill"
                          id="email"
                          autoComplete="off"
                        />
                        <label for="email">Enter amount as shown on the bill</label>
                      </div>

                      <div className="fixed-bottom">
                        <Link to={"/mobilepaymentbooking"}>
                          <button>Next</button>
                        </Link>
                      </div>
                      {/* <Link to={"/mobilepaymentbooking"}>
            <button>Next</button>
          </Link> */}
                    </div>
                  </div>
                </div>
              )}
            </section>
          </div>
        </>
      )
      }


      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        fullscreen="sm-down"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // className=""
        className={`custom-modal ${theme === "dark" ? "dark-theme" : ""}`}
      >
        {/* <Modal.Dialog style={{ maxWidth: '600px', margin: '0 auto' }}> */}{" "}
        <Modal.Header
          style={{
            width: "100%",
            position: "absolute",
            bottom: "78%",
            border: "none",
          }}
          className="cust-title"
        >
          <Modal.Title className="custom-title">
            <div className="badgess ">
              <div className="badgeschild">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100"
                  height="100"
                  viewBox="0 0 137 137"
                  fill="none"
                >
                  <g opacity="0.01">
                    <path
                      d="M68.1708 0.658203C30.5209 0.658203 0 31.1795 0 68.8294C0 106.479 30.5209 137 68.1708 137C105.821 137 136.342 106.479 136.342 68.8294C136.342 31.1795 105.821 0.658203 68.1708 0.658203Z"
                      fill="#66CE1C"
                    />
                  </g>
                  <path
                    d="M68.1703 17.573C39.8621 17.573 16.9141 40.5213 16.9141 68.8295C16.9141 97.1377 39.8621 120.086 68.1703 120.086C96.4785 120.086 119.427 97.1377 119.427 68.8295C119.427 40.5213 96.4785 17.573 68.1703 17.573Z"
                    fill="#173303"
                  />
                  <g opacity="0.05">
                    <path
                      d="M68.1703 17.573C39.7295 17.6354 16.8927 40.5647 16.9141 68.8295C16.9383 94.8271 35.993 116.016 60.9321 119.563C63.2957 119.9 65.7122 120.077 68.1703 120.086C94.7197 120.115 116.232 97.848 116.255 68.8684C116.277 39.9342 94.6999 17.5682 68.1703 17.573Z"
                      fill="white"
                    />
                  </g>
                  <path
                    d="M42.626 70.3052L58.643 86.046L94.2669 50.9744"
                    stroke="#9EE76F"
                    stroke-width="8"
                  />
                </svg>
                <h4 className="paymenticon text-center">
                  Booking Confirmation
                </h4>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={dynamicStyle}>
          <div className="model-body popupdetails d-none d-sm-block">
            <h5 className="usertitle">
              {" "}
              {takeawayName} your booking has been confirmed
            </h5>
            <hr />

            <div className="d-flex justify-content-around flex-wrap ">
              <div>
                <h5 className="offertitle">
                  <b>Address:</b>
                </h5>
                <h6 className="custdetails">{bookingData?.firstname}  {bookingData?.lastname}</h6>
                <p className="address">
                  <br /> <br />{" "}
                </p>
                <h6 className="details">
                  <b>Number of Dinners: {bookingData?.people} people</b>
                </h6>
                <h6 className="details">
                  {" "}
                  <b>Mobile : {bookingData?.phone}</b>
                </h6>
                <h6 className="details">
                  {" "}
                  <b>Email : {bookingData?.email}</b>
                </h6>
              </div>
              <div>
                <div className="buttons">
                  <span className="content">
                    <h2>{bookingDate.getDate()}</h2>
                    <h4>{formattedDate.split(" ")[1]}</h4> {/* Month */}
                    <h4>{bookingData?.time}</h4>
                    <hr />
                    <h4>Ref No:</h4>
                    <h4>DRW2023</h4>
                  </span>
                  <span className="badges">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_6151_1906)">
                        <path
                          d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                          fill="url(#paint0_linear_6151_1906)"
                        />
                        <path
                          d="M32.2594 16.0166C32.1215 15.5923 31.7549 15.2831 31.3135 15.219L24.222 14.1885L21.0506 7.76258C20.8532 7.36258 20.4458 7.10938 19.9997 7.10938C19.5537 7.10938 19.1463 7.36258 18.9489 7.76266L15.7775 14.1886L8.686 15.2191C8.24459 15.2832 7.87779 15.5924 7.73998 16.0166C7.60217 16.4409 7.71717 16.9066 8.03654 17.2179L13.168 22.2198L11.9566 29.2826C11.8812 29.7222 12.0619 30.1666 12.4228 30.4288C12.7837 30.6909 13.2621 30.7255 13.6569 30.518L19.9997 27.1834L26.3426 30.518C26.7404 30.727 27.2185 30.689 27.5767 30.4288C27.9376 30.1666 28.1183 29.7223 28.043 29.2826L26.8315 22.2198L31.963 17.2179C32.2823 16.9065 32.3972 16.4408 32.2594 16.0166Z"
                          fill="url(#paint1_linear_6151_1906)"
                        />
                      </g>
                      <defs>
                        <linearGradient
                          id="paint0_linear_6151_1906"
                          x1="20"
                          y1="40"
                          x2="20"
                          y2="0"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#FD5900" />
                          <stop offset="1" stop-color="#FFDE00" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_6151_1906"
                          x1="19.9997"
                          y1="30.6526"
                          x2="19.9997"
                          y2="7.10938"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#FFE59A" />
                          <stop offset="1" stop-color="#FFFFD5" />
                        </linearGradient>
                        <clipPath id="clip0_6151_1906">
                          <rect width="40" height="40" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="d-block d-md-none d-sm-none">
            <div
              className="d-block d-sm-none primarycards"
              style={{ width: "100%", border: "none" }}
            >
              {/* <div className="custom-card-header d-flex justify-content-between align-items-center">
        <div>
          <FaArrowLeft  />
        </div>
        <div className="mobileback">
          <IoChevronBack
        onClick={() => setModalShow(false)}
            style={{ color: "#000" }}
          />
        </div>
        <div className="text-center flex-grow-1 text-right">
          <h5>Book a Seat</h5>
        </div>
      </div> */}
              <div className="d-flex gap-3 " style={{ margin: "10px" }}>
                <div className="mobileback">
                  <IoChevronBack
                    onClick={handleNavClicktoback}
                    style={{ color: "#000" }}
                  />
                </div>
                <div className="gap-4">
                  <h5 >Request Received</h5>
                </div>
              </div>
              <div>
                <div className="text-center custom-title-header">
                  {takeawayName}
                </div>


                <div
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "normal",
                    textAlign: "center",
                  }}
                >
                  Reservation Details
                </div>
              </div>
              <div className="text-center" style={{ padding: "10px" }}>
                <h5> Booking Confirmed</h5>
                {/* <img src={ConfirmIMg} alt="" /> */}
              </div>
            </div>
            <UserDetail />
            {/* <Occasion /> */}
            {/* <Offer /> */}
          </div>
        </Modal.Body>
        <hr className="line" />
        <Modal.Footer className="status-button">
          <button onClick={handleCheckStatus}>Check status</button>
        </Modal.Footer>
        {/* </Modal.Dialog> */}
      </Modal>
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-contentreview">
            <Button className="close-btnmenu" onClick={closeModal}>
              <MdCancel />
            </Button>
            <form onSubmit={handleSubmit}>
              <h2>Enter your Review  ? </h2>
              <input
                type="text"
                placeholder="Enter Your Review"
                value={message}
                onChange={handleMessageChange}
                className="review-input"
                required
              />
              <button
                type="submit"
                className="send-button"
              >
                {buttonLoading ? (
                  <Spinner animation="border" size="sm" variant="light" />
                ) : (
                  "Send"
                )}
              </button>
            </form>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
          </div>
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  response: state.mainTableBooking?.response,
  tablegalleryresponse: state.tableBookGallery.response,
  tablegalleryisLoading: state.tableBookGallery,
  tablegalleryerror: state.tableBookGallery,
  response: state.getReviewDetail?.response,
  isLoading: state.getReviewDetail?.isLoading,
  error: state.getReviewDetail?.error,
});

const mapDispatchToProps = {
  getMainTableBooking,
  getReviewDetail,
  getTableGalleryDetail,
};

export default connect(mapStateToProps, mapDispatchToProps)(Tablebook);

